module.exports = __webpack_public_path__ + "img/loadingImg.e85c38ee.svg";